'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactScroll = require('react-scroll');
var _containers = require('../../containers');
var _components = require('../../components');
var _PublishPropertyFormConstants = require('../PublishForm/PublishPropertyFormConstants');
var _PropertiesFilterContainer = require('../PropertiesFilterContainer/PropertiesFilterContainer.scss');var styles = _interopRequireWildcard(_PropertiesFilterContainer);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var ProjectFilters = function ProjectFilters(props) {return (
    _react2.default.createElement('form', { id: props.formId, onSubmit: props.handleSubmit, className: styles.projectsFiltersForm },
      _react2.default.createElement('div', null,
        _react2.default.createElement('span', { className: styles.locationTitle }, props.translate('searchContainer', 'location')),

        _react2.default.createElement('div', { className: styles.locationInput },
          _react2.default.createElement(_components.HomePageLocationInput, {
            placeholder: '' + props.translate('searchContainer', 'search_address'),
            theme: _PublishPropertyFormConstants.inputStyleTheme,
            locale: props.locale,
            getInputData: props.getInputLocation,
            clearable: true,
            locationValue: props.locationValue,
            clearInput: props.clearInputLocation,
            isMobile: props.isMobile })),



        _react2.default.createElement('div', { className: 'form-group' },
          _react2.default.createElement('div', { className: (0, _classnames2.default)('formFields', styles.multiselectWrapper) },
            _react2.default.createElement('div', { className: 'label' }, props.translate('searchContainer', 'property_type')),

            _react2.default.createElement(_containers.MultiselectWrapper, {
              className: styles.multiSelects,
              options: props.typesInput,
              title: props.typesTitle,
              value: props.propertyTypes,
              onChange: function onChange(value) {return props.handleChange('propertyTypes', value);} })),



          _react2.default.createElement('div', { className: 'formFields' },
            _react2.default.createElement('div', { className: 'label' }, props.translate('searchContainer', 'price')),

            _react2.default.createElement('div', { className: styles.priceWrapper },
              _react2.default.createElement(_components.MinMaxPrices, {
                inFilters: true,
                isMobile: props.isMobile,
                translate: props.translate('searchContainer'),
                minPrice: props.formatPriceParameters('minPrice'),
                maxPrice: props.formatPriceParameters('maxPrice') }),

              _react2.default.createElement('span', { className: styles.currency }, '\u20AA'))),



          _react2.default.createElement(_reactScroll.Element, { name: 'rooms-dropdown', className: 'formFields' },
            _react2.default.createElement('div', { className: 'label' }, props.translate('searchContainer', 'rooms')),

            _react2.default.createElement(_containers.MultiselectWrapper, {
              options: props.roomInput,
              title: props.roomTitle,
              value: props.rooms,
              onChange: function onChange(value) {return props.handleChange('rooms', value);},
              onOpen: function onOpen() {return setTimeout(function () {return props.scrollTo('rooms-dropdown', {
                    containerSelector: '#filters-form',
                    containerId: 'filters-form' });},
                100);} })),



          _react2.default.createElement(_reactScroll.Element, { name: 'statuses-dropdown', className: 'formFields' },
            _react2.default.createElement('div', { className: 'label' }, props.translate('searchContainer', 'status')),

            _react2.default.createElement(_containers.ProjectStatusDropdown, {
              selectedStatuses: props.status,
              locale: props.locale,
              translate: props.translate,
              handleChange: function handleChange(val) {return props.handleChange('status', val);},
              onOpen: function onOpen() {return setTimeout(function () {return props.scrollTo('statuses-dropdown', {
                    containerSelector: '#filters-form',
                    containerId: 'filters-form' });},
                100);} }))))));};







ProjectFilters.propTypes = {
  formId: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  typesInput: _propTypes2.default.array,
  propertyTypes: _propTypes2.default.array,
  typesTitle: _propTypes2.default.string,
  roomInput: _propTypes2.default.array,
  rooms: _propTypes2.default.array,
  roomTitle: _propTypes2.default.string,
  locationValue: _propTypes2.default.string,
  handleChange: _propTypes2.default.func,
  handleSubmit: _propTypes2.default.func,
  scrollTo: _propTypes2.default.func,
  getInputLocation: _propTypes2.default.func,
  clearInputLocation: _propTypes2.default.func,
  formatPriceParameters: _propTypes2.default.func,
  status: _propTypes2.default.array };exports.default =


ProjectFilters;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MobilePropertiesFilters/ProjectFilters.js
// module id = 2963
// module chunks = 0